import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import trashIcon from '@jetbrains/icons/trash';
import LoaderInline from '@jetbrains/ring-ui/components/loader-inline/loader-inline';
import { useSelector } from 'react-redux';
import SmartToolsPreview from '@app/pages/profiles/profile-details/profile-ide-provisioner/common/smart-tools-preview';
import { SettingLayout } from '@app/pages/profiles/profile-details/profile-ide-provisioner/common/setting-layout';
import { PluginRule } from '@app/pages/profiles/profile-details/profile-ide-provisioner/plugin-rules/bundles/plugin-rule';
import { useEvaluatedSettingFilters } from '@common/queries/profile-evaluations';
import { getApplications } from '@common/store/profiles/selectors';
import styles from './plugin-rules-bundle.css';
export function PluginRulesBundle(props) {
    const { bundle, onClick, onDelete, className } = props;
    const applications = useSelector(getApplications);
    const { isFetching: isFilterToolsLoading, data: filterTools } = useEvaluatedSettingFilters(applications.rules, bundle.filters);
    return (_jsx(SettingLayout, { icons: [
            {
                glyph: trashIcon,
                onClick: () => {
                    onDelete(bundle);
                },
                title: 'Remove plugin rule'
            }
        ], onTileClick: () => onClick(bundle), className: className, children: _jsxs("div", { className: styles.wrapper, children: [_jsx("div", { children: !isFilterToolsLoading && filterTools ? (_jsx(SmartToolsPreview, { tools: filterTools })) : (_jsx(LoaderInline, {})) }), bundle.rules.map(rule => {
                    const key = `${bundle.id}-${JSON.stringify(rule)}-${bundle.rules.indexOf(rule)}`;
                    return _jsx(PluginRule, { rule: rule, className: styles.rule }, key);
                })] }) }));
}
